import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BasicPageComponent } from './basic-page.component';
import { SubcontentBulletsComponent } from './subcontent/subcontent-bullets/subcontent-bullets.component'
import { SubcontentComponent } from './subcontent/subcontent.component'
import { SubcontentLinksComponent } from './subcontent/subcontent-links/subcontent-links.component'
import { SubcontentViewComponent } from './subcontent/subcontent-view/subcontent-view.component'
import { BasicPageGalleryComponent } from './gallery/basic-page-gallery.component'
import { BasicContentComponent } from './basic-content/basic-content.component'
import { SharedModule } from '../shared/shared.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    SharedModule,
    CarouselModule,
    PipesModule
  ],
  declarations: [
    BasicPageComponent,
    SubcontentBulletsComponent,
    SubcontentComponent,
    SubcontentLinksComponent,
    SubcontentViewComponent,
    BasicPageGalleryComponent,
    BasicContentComponent
  ],
  exports: [BasicPageComponent],
  providers: [],
})
export class BasicPageModule { }
